/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking401,
  GetApiV1IndividualpaymentParcelsParcelidOrderTracking500,
} from "../../types/individualPaymentTraceabilityController/GetApiV1IndividualpaymentParcelsParcelidOrderTracking.ts";

function getGetApiV1IndividualpaymentParcelsParcelidOrderTrackingUrl(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams["parcelId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/individualpayment/parcels/${parcelId}/order-tracking` as const,
  };
  return res;
}

/**
 * @description Retorna os logs de pedido (GA_FINANCIAL_ORDER_LOG) da parcela com o tipo por extenso, mais recentes primeiro. Migrado do legado IndividualPayment/LoadParcelOrderTrackingGridDataAsync. **(Requer Authorization para autenticação)**
 * @summary Retorna o rastreio de pedidos financeiros de uma parcela (Requer Authorization para autenticação)
 * {@link /api/v1/individualpayment/parcels/:parcelId/order-tracking}
 */
export async function getApiV1IndividualpaymentParcelsParcelidOrderTracking(
  parcelId: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingPathParams["parcelId"],
  params?: GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1IndividualpaymentParcelsParcelidOrderTrackingQueryResponse,
    ResponseErrorConfig<
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking401
      | GetApiV1IndividualpaymentParcelsParcelidOrderTracking500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1IndividualpaymentParcelsParcelidOrderTrackingUrl(
      parcelId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
